import { DateView, DesktopDatePicker } from '@mui/x-date-pickers';
import { SxProps, Theme } from '@mui/material';
import { FC, FocusEventHandler, useCallback } from 'react';

interface Props {
  className?: string;
  sx?: SxProps<Theme>;
  id?: string;
  name?: string;
  label?: React.ReactNode;
  value?: Date | null;
  error?: boolean;
  required?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
  disablePast?: boolean;
  onChange: (value?: Date | null) => void;
  onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  shouldDisableDate?: (day: Date) => boolean;
  disableHighlightToday?: boolean;
}

export const QcsDatePicker: FC<Props> = ({
  className,
  sx,
  id,
  name,
  label,
  value,
  error,
  required,
  helperText,
  disabled,
  disablePast,
  onChange,
  onBlur,
  shouldDisableDate,
  disableHighlightToday,
}) => {
  const handleViewChange = useCallback((view: DateView) => {
    if (view === 'year') {
      requestAnimationFrame(() => {
        const selected = document.querySelector<HTMLElement>('.MuiYearCalendar-root [aria-checked="true"]');
        selected?.scrollIntoView({ block: 'center' });
      });
    }
  }, []);

  return (
    <DesktopDatePicker
      className={className}
      //Dont use required parameter.
      label={required ? <>{label} *</> : label}
      value={value}
      disabled={disabled}
      disablePast={disablePast}
      onChange={onChange}
      onViewChange={handleViewChange}
      shouldDisableDate={shouldDisableDate}
      disableHighlightToday={disableHighlightToday}
      slotProps={{
        textField: {
          sx,
          onBlur,
          name,
          error,
          helperText,
          id,
        },
        desktopTrapFocus: {
          disableEnforceFocus: true,
        },
      }}
      // renderInput={(params) => (
      //   <TextField
      //     {...params}
      //     id={id}
      //     onBlur={onBlur}
      //     name={name}
      //     error={error}
      //     helperText={helperText}
      //   />
      // )}
    />
  );
};
